import { GET_FILE_PATH } from "../constants/swrKey";
import { getFilePaths } from "../services/getFilePath";
import { useSwrManagement } from "./useSwrManagement";

const fetcher = async (s3Keys: string[], explicitToken?: string) => {
  if (!s3Keys.length || !explicitToken) {
    return [];
  }

  const path = await getFilePaths(s3Keys, explicitToken);
  return path;
};

export const useGetFilePaths = (s3Keys: string[], explicitToken?: string) => {
  const swrKey = createSWRKey(s3Keys);

  const { data: path } = useSwrManagement({
    swrKey,
    fetcher: () => fetcher(s3Keys, explicitToken),
  });

  return path;
};

const createSWRKey = (s3Keys: string[]) => {
  return [GET_FILE_PATH, ...s3Keys].join("|");
};
